import React, { useEffect, useState } from 'react';
import { DatePicker } from 'rsuite';
import axiosInstance from '../../../../../http-common';

const BacklogTimeDatePicker = ({
  id,
  field,
  row,
  rowNode,
  colDef,
  cellMode,
  hasFocus,
  tabIndex,
  value,
  formattedValue,
  isEditable,
  api,
}) => {
  const [dt, setDt] = useState(null);

  useEffect(() => {
    // console.log(value);
    // only set date when it's truthy
    if (value) {
      setDt(new Date(value));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = async (e) => {
    const date = new Date(e);
    const dd = date.getDate();
    const mm = date.getMonth();
    const yyyy = date.getFullYear();
    const hh = date.getHours();
    const min = date.getMinutes();
    const ss = date.getSeconds();

    const d = `${yyyy}-${mm + 1}-${dd} ${hh}:${min}:${ss}`;
    const { batch_number, "Material Type": material_type } = row;
    console.log(api, field);
    console.log(field, row);
    const body = {
      batch_number,
      field_to_update: field,
      value: d,
      material_type: material_type
    };
    try {
      const response = await axiosInstance.patch(`/v1/qc/backlog_po/`, body);
      const result = (await response)?.data;
      console.log({ result });
      const status = result?.status;
      console.log({ status });
      if (status === "success") {
        api?.updateRows([{ id, [field]: e }]);
        setDt(date);
        console.log({ d });
      }
    } catch (error) {
      console.log({ error });
    }
  };
  return (
    <div>
      <DatePicker
        format='yyyy-MM-dd HH:mm'
        calendarDefaultDate={dt}
        style={{ width: 200 }}
        value={dt}
        onChange={handleChange}
      />
    </div>
  );
};

export default BacklogTimeDatePicker;